import {useCallback, useState} from 'react';
import {REQUEST_STATUS} from '../../../constant/Application';
import ApiService from '../../../service/ApiService';
import AnalyticsService from '../../../service/AnalyticsService';

function useSubmit(params) {
  const {formValues} = params;
  const [requestStatus, setRequestStatus] = useState(null);
  const [submissionErrors, setSubmissionErrors] = useState(null);

  const onSubmit = useCallback(async () => {
    setRequestStatus(REQUEST_STATUS.IN_PROGRESS);

    const response = await ApiService.submit(formValues);

    // The only place the form's outcome is known: it reported every step advance but
    // never its own completion, so the primary conversion was invisible.
    if (response.success) {
      AnalyticsService.trackLead();
    } else {
      AnalyticsService.trackSubmitError(response.error);
      setSubmissionErrors(response.error);
    }

    setRequestStatus(response.success ? REQUEST_STATUS.SUCCEEDED : REQUEST_STATUS.FAILED);
  }, [formValues]);

  return {
    onSubmit,
    requestStatus,
    submissionErrors
  };
}

export default useSubmit;
